const decodeState =  stateURLParam => { return JSON.parse(new Buffer(decodeURIComponent(stateURLParam), 'base64').toString()) };

const encodeState = stateObj => { return encodeURIComponent(btoa(JSON.stringify(stateObj))) };

export default {
    encode: encodeState,
    decode: decodeState
}


// WEBPACK FOOTER //
// ./src/app/helpers/codifyURLStateParams.js